import React, { useEffect} from "react";
import {connect} from "react-redux";
import {
    setgeneralDetails,
    setLoginDetails, setVisitorData, setVisitorSubmissionData,
} from "../../actions/actions";


function Logout(props) {

    const onLogout = () => {
        window.sessionStorage.setItem("isLoggedIn", false);
        window.sessionStorage.clear();
        props.setOnLoginDetails([])
        props.setOnSubmissionDetails([])
        props.setOnVisitorDetails([])
        props.setOnGeneralDetails("")
        window.location.href = '/';
    }

    useEffect(()=>{
        onLogout();
    }, [""])


}

const mapStateToProps = (state) => {
    return {
        loginData: state.loginDetails,
    };
};

const mapDisptachToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnSubmissionDetails: (p) => {
            dispatch(setVisitorSubmissionData(p));
        },
        setOnVisitorDetails: (p) => {
            dispatch(setVisitorData(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setgeneralDetails(p));
        },
    };
};


export default connect(mapStateToProps, mapDisptachToProps)(Logout);
